import PropTypes from 'prop-types';

export const Medication = PropTypes.shape({
  drugId: PropTypes.string.isRequired,
  genericDrug: PropTypes.shape({
    drugName: PropTypes.string.isRequired,
    activeIngredients: PropTypes.string.isRequired
  }).isRequired,
  brandNameDrugs: PropTypes.arrayOf(
    PropTypes.shape({
      drugName: PropTypes.string.isRequired,
      activeIngredients: PropTypes.string.isRequired
    })
  ).isRequired,
  drugForms: PropTypes.arrayOf(
    PropTypes.shape({
      mmdc: PropTypes.string.isRequired,
      productStrength: PropTypes.string,
      productRouteDesc: PropTypes.string.isRequired,
      form: PropTypes.string
    })
  ),
  ndcCoreDescriptions: PropTypes.arrayOf(
    PropTypes.shape({
      ndcFormatted: PropTypes.string.isRequired,
      obsoleteDate: PropTypes.string
    })
  )
});
